import { Component, OnDestroy } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { Subscription } from 'rxjs';

import { SharedService } from '@services/shared.service';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnDestroy {

    isSpinnerVisible = true;

    imageSrc = 'assets/images/spinner1.gif';

    private loadingSubscription: Subscription = null;
    private navigationSubscription: Subscription = null;

    constructor(private router: Router, public sharedService: SharedService) {

        // subscribe to the router events. Company the subscription so we can unsubscribe later.
        // Set loading from routing navigation
        this.navigationSubscription = this.router.events.subscribe(
            (event: any) => {

                const isApp = navigator.userAgent.toLowerCase().indexOf('canvas') > -1;
                // No mostrar loading al navegar is app (Mobiloud)
                // If it is a NavigationStart event
                if (event instanceof NavigationStart && !isApp) {

                    if (this.sharedService.showPreLogin) return;
                    this.isSpinnerVisible = true;
                }
                if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {

                    this.isSpinnerVisible = false;
                }
            },
            (err: any) => {

                this.isSpinnerVisible = false;
            }
        );

        // Set loading from state manual
        this.loadingSubscription = this.sharedService.loadingSubject.subscribe((isVisible: boolean) => {
            if (this.sharedService.showPreLogin && isVisible) return;
            setTimeout(() => {
                this.isSpinnerVisible = isVisible;
            }, 100);
        });
    }

    ngOnDestroy() {

        this.isSpinnerVisible = false;

        if (this.loadingSubscription) { this.loadingSubscription.unsubscribe(); }
        if (this.navigationSubscription) { this.navigationSubscription.unsubscribe(); }
    }
}
